module.exports = __webpack_public_path__ + "img/role05.d4487fda.png";